import {Button, Checkbox} from "antd";
import {useTranslation} from "react-i18next";
import {CertificateListItemDto, CertificateListParameterDto} from "../generated-api";
import {XCircle} from "react-feather";
import {NotDefined} from "./NotDefined";
import {TEMPLATE_PARAM_DATE} from "../constants/template";
import {renderDate} from "../utils/render";
import { useEffect, useState } from "react";

interface CertificatesListProps {
    certificates: CertificateListItemDto[];
    multiSelect?: boolean;
    columns?: CertificateListParameterDto[];
    onSelectMultipleCertificates?: any;
    onClick?: any;
    onRemove?: any;
}

export function CertificatesList({certificates, multiSelect, columns = [], onSelectMultipleCertificates, onClick, onRemove}: CertificatesListProps) {
    const {t} = useTranslation();

    const [selectedCertificates, setSelectedCertificates] = useState<any>({});
    
    useEffect(() => {
        if (onSelectMultipleCertificates)
            onSelectMultipleCertificates.current = () => selectCertificates(selectedCertificates);
      }, [selectedCertificates]);

    const selectCertificates = (certificates: CertificateListItemDto[]) => {
       onClick(Object.values(certificates));
    };

    const toggleSelect = (certificate: CertificateListItemDto) => {

        if (certificate.id === undefined)
            return;

        let selected  = {...selectedCertificates};

        if (selected[certificate.id])
            delete selected[certificate.id];
        else
            selected[certificate.id] = certificate;

        setSelectedCertificates({...selected});
    }

    const renderParameterValue = (column: CertificateListParameterDto, value: string | undefined) => {
        if (!value)
            return <NotDefined />
        
        if (column.type === TEMPLATE_PARAM_DATE) {
            return renderDate(value);
        } 

        return value;
    }
    return (
        <>
            {(certificates || []).map((certificate: CertificateListItemDto, index: number) =>
                <div key={index} className={'card accent4-background'}>
                    <a className={'flex-auto text-transform-none'} href={'/certificates/' + certificate.id}
                       onClick={event => {
                           event.preventDefault();
                           if (multiSelect){
                                toggleSelect(certificate);
                                return;
                            }

                           !!onClick && onClick(certificate);
                       }}>
                        <div className={'card-header flex-row flex-wrap pb-0'}>
                            {
                                multiSelect === true
                                ? <div className={'pr-1 pt-05'}><Checkbox checked={selectedCertificates[certificate.id || '']} /></div>
                                : ''
                            }
                            {(columns || []).sort((a, b) => (a.order || 0) - (b.order || 0)).map((column, index) => <div key={index} className={'flex-1 pr-05 mw-100'}>
                                <label>
                                    {column.title}
                                </label>
                                <p>
                                    {renderParameterValue(column, (certificate.parameters.find(item => item.parameterId === column.parameterId) || {}).value)}
                                </p>
                            </div>)}
                            <div>
                                <label>
                                    {t('templates.creationDate')}
                                </label>
                                <p>
                                    {renderDate(certificate.created)}
                                </p>
                            </div>
                            {!!onRemove && <div className={'flex-auto text-right'}>
                                <Button type={'link'} onClick={() => onRemove(certificate)}>
                                    <XCircle className={'ant-typography ant-typography-danger'}/>
                                </Button>
                            </div>}
                        </div>

                    </a>
                </div>
            )}
            {(!certificates || !certificates.length) && <div className={'no-data'}>{t('general.noData')}</div>}
        </>
    );
}
